import { Select } from '..'
import styled from 'styled-components'

export const StyledSelect = styled(Select)`
  width: 100%;
`
